import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';
import { Entities } from '../Enums/Entities.enum';

import { BatchBillingServiceContractsResultItem } from './BatchBillingServiceContractsResultItem.entity';
import { ValidationMessage } from './ValidationMessage.entity';

export class BatchBillingServiceContractsResult<
  T extends EMode = EMode.entity
> {
  /** Alias: items */
  items?: BatchBillingServiceContractsResultItem<T>[];
  /** Alias: errors */
  errors?: ValidationMessage<T>[];

  __typename?: string;
}

const fields: FieldDefinitions<BatchBillingServiceContractsResult> = {
  items: {
    alias: 'items',
    entity: Entities.batchBillingServiceContractsResultItem,
  },
  errors: {
    alias: 'errors',
    entity: Entities.validationMessage,
  },
  __typename: {
    alias: '__typename',
  },
};

export const batchBillingServiceContractsResultEntityDefinition: EntitiyDefinition<BatchBillingServiceContractsResult> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'BatchBillingServiceContractsResult',
      withPaginationWrapper: false,
      mutations: {
        upsert: {
          mutationName: 'batchBillingServiceContracts',
          args: [
            { name: 'setting', type: 'BatchBillingServiceContractsRequest!' },
          ],
        },
      },
    },
    fieldDefinitions: fields,
  };
